export default __webpack_public_path__ + "static/media/investment-product.92e790ea.svg";